var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5638_24119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7905 17.29L18.5005 16V11C18.5005 7.93 16.8605 5.36 14.0005 4.68V4C14.0005 3.17 13.3305 2.5 12.5005 2.5C11.6705 2.5 11.0005 3.17 11.0005 4V4.68C8.13054 5.36 6.50054 7.92 6.50054 11V16L5.21054 17.29C4.58054 17.92 5.02054 19 5.91054 19H19.0805C19.9805 19 20.4205 17.92 19.7905 17.29ZM16.5005 17H8.50054V11C8.50054 8.52 10.0105 6.5 12.5005 6.5C14.9905 6.5 16.5005 8.52 16.5005 11V17ZM12.5005 22C13.6005 22 14.5005 21.1 14.5005 20H10.5005C10.5005 21.1 11.3905 22 12.5005 22Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5638_24119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.0c8204a18f1beda2b5ab7ff522edfcb0.svg";
export { ForwardRef as ReactComponent };